// library imports
import React, { useEffect } from "react";

// User Component imports
import { useDevice, deviceType } from '_core/managers/ResponsiveManager'

// styles imports
import './LayoutElement.scss';

const PageSideContents = (props) => {
    const device = useDevice();
    const [open, setOpen] = React.useState(false);
    const [isInitialized, setIsInitialized] = React.useState(false);

    useEffect(() => {
        setIsInitialized(true);
    },[]);

    // device が変更された場合に open を更新
    useEffect(() => {
        if (isInitialized)
        {
            setOpen(device === deviceType.desktop.type);
        }
    }, [isInitialized, device]);  // device が依存配列に追加

    const handleSideContentSwitch = () => {
        setOpen(!open);
    };

    return (
        <div className={"side-content " +  (open ? "" : "side-close ")}>
            {/* {device !== deviceType.desktop.type &&
                <div size="small" color="primary" className="side-fixed-button" onClick={handleSideContentSwitch}>
                    {open ? (<ChevronRight />) : (<ChevronLeft />)}
                </div>
            } */}
            <div className="side-scroll-parent">
                <div className="side-container">
                    {props.children}
                </div>
            </div>
        </div>
    );
};

export default PageSideContents;